import {
  ADD_SENDER_WAREHOUSE_FAIL,
  ADD_SENDER_WAREHOUSE_REQUEST,
  ADD_SENDER_WAREHOUSE_SUCCESS,
  DELETE_SENDER_WAREHOUSE_FAIL,
  DELETE_SENDER_WAREHOUSE_REQUEST,
  DELETE_SENDER_WAREHOUSE_SUCCESS,
  GET_SENDER_WAREHOUSE_LIST_REQUEST,
  GET_SENDER_WAREHOUSE_LIST_FAIL,
  GET_SENDER_WAREHOUSE_LIST_SUCCESS,
  GET_SINGLE_SENDER_WAREHOUSE_FAIL,
  GET_SINGLE_SENDER_WAREHOUSE_REQUEST,
  GET_SINGLE_SENDER_WAREHOUSE_SUCCESS,
  UPDATE_SENDER_WAREHOUSE_FAIL,
  UPDATE_SENDER_WAREHOUSE_REQUEST,
  UPDATE_SENDER_WAREHOUSE_SUCCESS,
} from "src/constants/types";

export const senderWarehouseReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_SENDER_WAREHOUSE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SENDER_WAREHOUSE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        senderWarehouses: actions.payload,
        error: "",
      };
    case GET_SENDER_WAREHOUSE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_SENDER_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_SENDER_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_SENDER_WAREHOUSE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_SENDER_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_SENDER_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_SENDER_WAREHOUSE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_SENDER_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_SENDER_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        senderWarehouse: actions.payload,
      };
    case GET_SINGLE_SENDER_WAREHOUSE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_SENDER_WAREHOUSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_SENDER_WAREHOUSE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_SENDER_WAREHOUSE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
